module.exports = __webpack_public_path__ + "img/green-check.8ed2a9a8.svg";